import { useParams } from "react-router-dom";
import Spinner from "../../../components/ui/spinner/Spinner";
import styles from "./styles/PosTicketSearch.module.css";
import { useContext, useEffect, useState } from "react";
import DataContext from "../../../context/DataContext";
import POSDataContext from "../../../context/POSDataContext";
import PosSearchForm from "./PosSearchForm";

import useCurrentBU from "../../../hooks/useCurrentBU";

/**
 * The ticket search page
 */
const PosTicketSearch = () => {
    const { bUser } = useParams(); // Extracts 'bUser' parameter from the URL.

    useCurrentBU(bUser);

    const {
        isServiceDataAvailable, // {Boolean} - Flag indicating if service data is available
        serviceData, // {Fuction} - The The function that fetch the service data
        currentBU, // {String} - The current business user
        isLoading, // {Boolean} - Flag indicating if data is loading
        JWTToken,
    } = useContext(DataContext);
    const {
        isLoadingPos, // {Boolean} - Flag indicating if data is loading in POS
        setFilterExpression, // {Function} - Function to set the filter expression state
        setIsValidSearchPos, // {Function} - Function to set the validity of the search state
        setIsLoadingPos, // {Function} - Function to set the loading data state in POS
        setIsProcessingPos, // {Function} - Function to set the processing state in POS
    } = useContext(POSDataContext);

    const [notReadyView, setNotReadyView] = useState(true);

    // Fetch service data if nos service data or business user changes
    useEffect(() => {
        bUser &&
            JWTToken &&
            (!isServiceDataAvailable || bUser !== currentBU) &&
            serviceData(bUser);
    }, [bUser, isServiceDataAvailable, JWTToken]);

    // Set the defaults
    useEffect(() => {
        setFilterExpression(null);
        setIsValidSearchPos(false);
        setIsProcessingPos(false);
        setIsLoadingPos(false);
    }, [bUser, isServiceDataAvailable]);

    // Check ready for viewing
    useEffect(() => {
        if (isServiceDataAvailable && (!isLoadingPos || !isLoading)) {
            const timer = setTimeout(() => {
                setNotReadyView(false);
            }, 50);

            // Cleanup function
            return () => {
                clearTimeout(timer);
            };
        }
    }, [isServiceDataAvailable, isLoadingPos, isLoading]);

    return (
        <article className={`main-page-container flex-container`}>
            {isLoadingPos || isLoading ? (
                <Spinner />
            ) : (
                <main
                    className={`${styles.main_page_container} 
                    transition-container 
                    ${
                        notReadyView
                            ? "transition-hidden"
                            : "transition-visible"
                    }   
                    main-container flex-container`}
                >
                    <PosSearchForm />
                </main>
            )}
        </article>
    );
};

export default PosTicketSearch;
